import { render, staticRenderFns } from "./DesignTextarea.vue?vue&type=template&id=ed2f3c12&scoped=true&"
import script from "./DesignTextarea.vue?vue&type=script&lang=js&"
export * from "./DesignTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2f3c12",
  null
  
)

export default component.exports